import { render, staticRenderFns } from "./PortfolioStrategySelect.vue?vue&type=template&id=59a9da8e"
import script from "./PortfolioStrategySelect.vue?vue&type=script&lang=js"
export * from "./PortfolioStrategySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports